import React from 'react';

import makeFeatureRenderer from '@sitebase/make-feature-renderer';
import { MediaProvider } from '@sitebase/media-context';
import makeFeatureRendererInPortal from './makeFeatureRendererInPortal';

import { Header } from './header/Header';
import { useHeaderType } from './useHeaderType';

export const NewHeader = ({ deviceType, buildDeviceType, config, jurisdiction, locale, buildVertical, renderers, content }) => {

  const renderFeature = makeFeatureRenderer(renderers);
  const renderToPortal = makeFeatureRendererInPortal(renderers);

  const subNavStart = config.subNavStart && renderFeature(config.subNavStart);
  const subNavEnd = config.subNavEnd && renderFeature(config.subNavEnd);

  const productMenuItems = config.productNav?.children?.map(({ data: { label, id, link: { url } } }) => ({ label, id, url })) || [];

  const newConfig = {
    productMenuItems
  };

  const headerType = useHeaderType();

  return <>
    <MediaProvider device={headerType}>
      {renderToPortal(config.actions)}
    </MediaProvider>
    <Header
      deviceType={deviceType}
      buildDeviceType={buildDeviceType}
      config={newConfig}
      content={content}
      jurisdiction={jurisdiction}
      locale={locale}
      buildVertical={buildVertical}
      subNavStart={subNavStart}
      subNavEnd={subNavEnd}
      modals={null}
    />
  </>
}
